export const setFaviconAndTitle = (buildName) => {
  var link = document.querySelector("link[rel~='icon']");
  
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  };
  if (buildName === 'tazadeal') {
    link.href = './favicon/favicon_tazadeal_32.ico';
    document.title = 'TazaDeal';
  } else if (buildName === 'athena') {
    link.href = './favicon/favicon_athena_32.ico';
    document.title = 'Athena';
  }
}
